import { a as c } from "../../../vendor-CPVnY93G.js";
import { useCallback as f } from "react";
const u = {
  error: "alert",
  global: "banner",
  info: "status",
  success: "status",
  warning: "alert"
}, d = {
  error: "assertive",
  global: "off",
  info: "polite",
  success: "polite",
  warning: "assertive"
};
function v({
  onDismiss: a,
  variant: s = "info",
  dismissAriaLabel: o = "Dismiss",
  ...e
} = {}) {
  const r = e.isVisible !== void 0, [i, l] = c(
    e.isVisible,
    e.defaultVisible ?? !0,
    // Preserve original semantics: `onDismiss` should only fire when `dismiss()` is invoked.
    void 0
  ), t = f(() => {
    i && (a?.(), r || l(!1));
  }, [i, r, a, l]), n = u[s], b = d[s];
  return {
    bannerProps: {
      "aria-atomic": !0,
      "aria-describedby": e["aria-describedby"],
      "aria-label": e["aria-label"],
      "aria-labelledby": e["aria-labelledby"],
      "aria-live": b,
      role: n
    },
    dismiss: t,
    dismissButtonProps: {
      "aria-label": o,
      onPress: t
    },
    state: {
      isVisible: i
    }
  };
}
export {
  v as useBanner
};
